import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import useAPI from '../../../api';
import { Fab, Tooltip } from '@mui/material';
import MarkChatReadRoundedIcon from '@mui/icons-material/MarkChatReadRounded';
import MessageFeedbackDialog from './Dialog';
import IconButton from '../IconButton';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { useAtomValue } from 'jotai';
import { activityOutcomesAtom } from '../../../Atoms';

const MessageFeedback = function MessageFeedback({
  id,
  onUpdate,
  campaignId,
  activityTypeName = 'SMS',
  detailsData = null,
}) {
  const intl = useIntl();
  const API = useAPI();
  const [open, setOpen] = useState(false);
  const activityOutcomes = useAtomValue(activityOutcomesAtom);

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const handleFeedbackMessage = (outcome) => {
    API.closeActivity(
      {
        activityId: id,
        campaignId,
        outcome,
      },
      () => {
        handleClose();
        onUpdate();
      }
    );
  };

  return (
    <>
      <MessageFeedbackDialog
        open={open}
        onClose={handleClose}
        onSubmit={handleFeedbackMessage}
        activityTypeName={activityTypeName}
        activityOutcomes={activityOutcomes}
        detailsData={
          detailsData
            ? {
                ...detailsData,
                outcomeName: activityOutcomes[activityTypeName]?.find(
                  ({ id }) => id === detailsData?.outcome
                )?.name,
              }
            : null
        }
      />
      {detailsData ? (
        <IconButton
          id="details-button"
          title="DETAILS"
          onClick={handleOpen}
          size="large"
        >
          <InfoOutlinedIcon />
        </IconButton>
      ) : (
        <Tooltip title={intl.messages.ADD_OUTCOME}>
          <Fab
            id={`feedback-fab-${id}`}
            color="primary"
            aria-label="feedback"
            onClick={handleOpen}
          >
            <MarkChatReadRoundedIcon />
          </Fab>
        </Tooltip>
      )}
    </>
  );
};

export default MessageFeedback;
